export const COUNTRY_KEY = "soko-country";
export const GOOGLE_MAPS_KEY = 'AIzaSyBvJq8y7K8QFtzAI0teTE0DAuAbEm6q0E8';